export default __webpack_public_path__ + "static/team7-e08ca29fc124f5de428d8354fae26d8f.jpg";